import { Injectable } from 'angular-ts-decorators';

import { SpynlBase } from './spynl-base';
import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';

/**
 * Factory in the sharedModule. It takes care of communication with event
 * resource. Methods are inherited form {@link sharedModule.spynlBase
 * spynlBase} service, and are documented there.
 *
 * # Data schema
 * {@link http://docs.dev.swcloud.nl/schemas/bower_components/docson/#../../spynl/event.json
 * is documented with json-schema}
 */
@Injectable('event')
export class Event extends SpynlBase<Object> {
  constructor(
    $http: ng.IHttpService,
    $q: ng.IQService,
    sentry,
    domain: Domain,
    config: IConfig,
    standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';

    super($http, $q, sentry, domain, config, standardErrorParser, Object);

    this.location = '/events';
  }
}
